export { PortableText as default } from './PortableText';
